export default "__VITE_ASSET__BUUUsUCu__"